// 9fbef606107a605d69c0edbcd8029e5d
import { CREATE_ACCOUNT_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const CREATE_ACCOUNT_CONSTANTS = {
  CREATE_AN_ACCOUNT: `${CREATE_ACCOUNT_ACTION_PATTERN}CREATE_AN_ACCOUNT`,
  CREATE_AN_ACCOUNT_ERR: `${CREATE_ACCOUNT_ACTION_PATTERN}CREATE_AN_ACCOUNT_ERR`,
  RESET_CREATE_AN_ACCOUNT_ERR: `${CREATE_ACCOUNT_ACTION_PATTERN}RESET_CREATE_AN_ACCOUNT_ERR`,
  SET_LOADING_STATE: `${CREATE_ACCOUNT_ACTION_PATTERN}SET_LOADING_STATE`,
  CREATE_ACCOUNT_FORM: 'CreateAccountForm',
  SET_SHOW_OTP_SCREEN: `${CREATE_ACCOUNT_ACTION_PATTERN}SET_SHOW_OTP_SCREEN`,
  IS_FROM_CREATE_ACCOUNT_FLOW: `${CREATE_ACCOUNT_ACTION_PATTERN}IS_FROM_CREATE_ACCOUNT_FLOW`,
  SHOW_VERIFICATION_ERROR: `${CREATE_ACCOUNT_ACTION_PATTERN}SHOW_VERIFICATION_ERROR`,
  SHOW_BRITE_ERROR: `${CREATE_ACCOUNT_ACTION_PATTERN}SHOW_BRITE_ERROR`,
  BRITE_ERROR_MESSAGE: `${CREATE_ACCOUNT_ACTION_PATTERN}BRITE_ERROR_MESSAGE`,
};

export default CREATE_ACCOUNT_CONSTANTS;
